import React from "react"
import Back from "../common/Back"
import PriceCard from "../home/price/PriceCard"
// import Recent from "../home/recent/Recent"
import img from "../images/pricing.jpeg"
import "../home/price/price.css"

const Pricing = () => {
  return (
    <>
      <section className='pricing mb'>
        <Back name="Let us take care of the details, so you can focus on making memories!" title='No Extra Fees. Friendly Support' cover={img} />
        
        <div className='price container'>
          <PriceCard />
        </div>
        {/* <Recent /> */}
      </section>
    </>
  )
}

export default Pricing
